module.exports = __webpack_public_path__ + "img/gift-01-c2.c7a3548d.png";